import React, { Fragment, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Context } from './Context'
import { NavData } from '../wbstdt/Wbstdt'

export default function Footer() {

    const { lang } = useContext(Context)

    return (
        <Fragment>
            <div id="footer">
                <div className="container flex-container-scattered box-wsp navbar">
                    <div className="bg-img contained-bg logo" style={{ backgroundImage: `url(${NavData.logo})` }}></div>
                    <div className="flex-container-scattered navlinks">
                        <div className="flex-container-scattered wbst-navlinks">
                            {NavData[lang].map((item, index) => {
                                return (
                                    <div key={index}>
                                        <Link to={NavData.links[index]}>
                                            {item}
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="flex-container-scattered scn-navlinks">
                            <a href="https://www.facebook.com/SafetyABS" target="_blank" rel="noopener noreferrer"><div className="bg-img contained-bg scn-navlinks-item" style={{ backgroundImage: `url(${NavData.fbIcon})` }}></div></a>
                            <a href="https://www.instagram.com/abs_safety/" target="_blank" rel="noopener noreferrer"><div className="bg-img contained-bg scn-navlinks-item" style={{ backgroundImage: `url(${NavData.igIcon})` }}></div></a>
                            <a href="https://www.linkedin.com/company/abssafety" target="_blank" rel="noopener noreferrer"><div className="bg-img contained-bg scn-navlinks-item" style={{ backgroundImage: `url(${NavData.inIcon})` }}></div></a>
                        </div>
                    </div>
                </div>
                <div className="container flex-container-scattered box-wsp credential">
                    <div>{`${lang === 'fr' ? 'Tous droits resérvés,' : 'All rights reserved, '} SARL ABS Safety ${new Date().getFullYear() === 2021 ? 2021 : `2021 - ${new Date().getFullYear()}`}`}</div>
                    <div>Designed &amp; Developed By <a href="https://kontextt.com" rel='noreferrer noopener' className="kontextt" target="_blank">@Kontextt</a></div>
                </div>
            </div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/Component/Footer.js